import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import DepositPaymentRequestRecive from 'assets/images/DepositPaymentRequestRecive.png';
import { postApiCall } from 'api/apiService';
import { POST_BUYER_BANNER_CLOSE } from 'constant/app.config';
import { useHistory } from 'react-router-dom';

const DepositPaymentRequestReceivedBanner = (props) => {
  const {
    isBuyerDashboard,
    buyerDashboardDetails,
    getBuyerIndividualValue,
    DashboardGroupCall,
    groupIt,
    setDepostPaymentRequestReceviedClose,
  } = props;
  const theme = useTheme();
  const history = useHistory();

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const PropertyId = isBuyerDashboard
    ? buyerDashboardDetails?.property?.propertyId
    : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;

  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);

  const winnerCheck =
    getBuyerIndividualValue?.PropertyDetails?.isWinnerId === userDetail?.userId;

  const closeHideForWinner =
    getBuyerIndividualValue?.PropertyDetails?.isWinner == 1 && winnerCheck;

  const [closeLoader, setCloseLoader] = useState(false);
  const handleDepositRecivedCloseApiCall = async () => {
    const propertyId = isBuyerDashboard
      ? buyerDashboardDetails?.property?.propertyId
      : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;
    let input = {
      propertyId: propertyId,
      bannerCode: 'BUYER003',
      bannerHeading: 'Deposit Received',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_BUYER_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        setDepostPaymentRequestReceviedClose((prev) =>
          prev.includes(propertyId) ? prev : [...prev, propertyId]
        );
        if (!isBuyerDashboard) {
          groupIt();
        }
        if (isBuyerDashboard) {
          DashboardGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={9} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 0.4 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    marginTop: '-10px',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Deposit Payment - Request Received
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  You have received a request to make a deposit payment for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName ||
                      buyerDashboardDetails?.propertyAddress?.streetName}
                  </Typography>
                  . By processing a deposit payment early, buyers are able to
                  strengthen their offers and highlight genuine commitment.
                  Deposits are refundable if your purchase is unsuccessful.
                </Typography>

                <Stack
                  direction="row"
                  spacing={matchessm ? 0 : 2}
                  mt={matchessm ? 1 : 2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  {!closeHideForWinner && (
                    <Button
                      disabled={closeLoader}
                      onClick={handleDepositRecivedCloseApiCall}
                      endIcon={
                        closeLoader && (
                          <CircularProgress color="inherit" size="20px" />
                        )
                      }
                      sx={{
                        px: 4,
                        height: matchessm ? 32 : 42,
                        borderRadius: '5px',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                        border: '1px solid #E6F2FF',
                        backgroundColor: 'transparent',
                        color: '#E6F2FF',
                        fontFamily: 'poppins',
                        fontWeight: 300,
                        '&:hover': {
                          bgcolor: 'rgb(33, 132, 253)',
                          color: '#E6F2FF',
                        },
                      }}
                    >
                      Close
                    </Button>
                  )}

                  <Box display="flex" alignItems="center">
                    <Button
                      onClick={() => {
                        if (isBuyerDashboard) {
                          history.push({
                            pathname: `market/${PropertyId}`,
                            state: {
                              propertyIds: true,
                              isDepositPaymentBanner: true,
                            },
                          });
                        } else {
                          history.push({
                            pathname: history.location.pathname,
                            state: {
                              propertyIds: true,
                              isDepositPaymentBanner: true,
                            },
                          });
                        }
                      }}
                      sx={{
                        px: 4,
                        height: matchessm ? 32 : 42,
                        borderRadius: '5px',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                        border: '1px solid #E6F2FF',
                        backgroundColor: '#FFF',
                        color: '#2184FD',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        '&:hover': {
                          bgcolor: '#FFFFFF',
                          color: '#2184FD',
                        },
                      }}
                    >
                      Process Payment
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={DepositPaymentRequestRecive}
                alt="Deposit Payment Request Recive"
                style={{ objectFit: 'contain', height: '265px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default DepositPaymentRequestReceivedBanner;
